<template>
  <div class="Exportjr2">
    <v-row>
      <!-- <v-col class="text-left">
        <v-btn type="button" color="yellow white white--text" @click=validation()>
          <span class="material-icons">verified_user</span>
          {{ $t("validation") }}
        </v-btn>
      </v-col> -->
      <v-col class="text-right">

           <download-excel
              :data = "papardatajr2"
              type="csv"
              name="jr2.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("jr2") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatajr2"
          :items-per-page="10"
          class="elevation-1"
          height="800"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
export default {
  Name: "Exportjr2",
  setup() {},
  props: ["papardatajr2", "exportthn", "exportbln", "exportps", "paparnegeriexport"],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem('tokenexport'),
    databatch: "",
    listValidation:[],
    headers: [
      { text: i18n.t("hid"), value: "HID" },
      { text: i18n.t("bno"), value: "BNO" },
      { text: i18n.t("Pusingan"), value: "P" },
      { text: i18n.t("s"), value: "S" },
      { text: i18n.t("negeri"), value: "NG" },
      { text: i18n.t("dp"), value: "DP" },
      { text: i18n.t("db"), value: "DB" },
      { text: i18n.t("bp"), value: "BP" },
      { text: i18n.t("st"), value: "ST" },
      { text: i18n.t("notk"), value: "NOTK" },
      { text: i18n.t("noir"), value: "NOIR" },
      //{ text: i18n.t("kaw"), value: "KAW" },
      { text: i18n.t("bulan"), value: "BULAN" },
      { text: i18n.t("tahun"), value: "TAHUN" },
      //{ text: i18n.t("negeri"), value: "NEGERI" },
      { text: i18n.t("jir"), value: "JIR" },
      { text: i18n.t("totjir"), value: "TOTJIR" },
      { text: i18n.t("tku"), value: "TK_ulangan" },
      { text: i18n.t("sampletk"), value: "SAMPLE TK" }, 
      { text: i18n.t("alamat"), value: "Alamat" , width: '500px'},
      { text: i18n.t("alamat1"), value: "Alamat1" },
      { text: i18n.t("alamat2"), value: "Alamat2" },
      { text: i18n.t("alamat3"), value: "Alamat3" }, 
      { text: i18n.t("Nama"), value: "Nama" },
      { text: i18n.t("KER"), value: "KER" },
      { text: i18n.t("Email"), value: "Email" },
      { text: i18n.t("poskod"), value: "Poskod" },
      { text: i18n.t("notelefon"), value: "Notelefon" },
      { text: i18n.t("r"), value: "R" },
      { text: i18n.t("jais"), value: "JAIS" },
      { text: i18n.t("jpp"), value: "JPP" },
      { text: i18n.t("kwkirb"), value: "KWKIRB" },
      { text: i18n.t("kkirb"), value: "KKIRB" },
      { text: i18n.t("pkkirb"), value: "PKKIRB" },
      { text: i18n.t("pnkirb"), value: "PNKIRB" },
      { text: i18n.t("jpkasb"), value: "JPKASB" },
      { text: i18n.t("penkasr"), value: "PENKASR" },
      { text: i18n.t("jperb"), value: "JPERB" },
      { text: i18n.t("noic"), value: "NOIC" },
      { text: i18n.t("Status"), value: "statusHID" },
     
     
    ],
  }),
  methods: {
    async exportexceljr2(tokenexport, exportthn,exportbln,exportps,paparnegeriexport){
      try {
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/sec/checksession`,
            {
                tokenexportsess: window.localStorage.getItem('tokenexport')
            }
          )
          .then(result=>{
            console.log(result.data.status)
            if(result.data.status){
              window.open(`${process.env.VUE_APP_API_URL}/JR/paparsemuadatajr2exportserverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`, '_blank');
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    // validation(){
    //   console.log(this.papardatajr2)
    //   var i = 0;
    //   var len = this.papardatajr2.length;

    //   while (i < len) {
    //     // your code
    //     i++
    //   }
      
    // }
  },
};
</script>